export const createCenterTextPlugin = (text, options = {}) => {
    return {
        id: "centerText",
        beforeDraw(chart) {
            const { width, height } = chart;
            const ctx = chart.ctx;
            ctx.restore();

            const lines = text.split("\n");
            const fontSize = (height / (options.divisor || 10)).toFixed(2);

            ctx.font = `${options.weight || "bold"} ${fontSize}px ${
                options.font || "sans-serif"
            }`;
            ctx.textBaseline = "middle";
            ctx.fillStyle = options.color || "#333";

            lines.forEach((line, index) => {
                const textX = Math.round((width - ctx.measureText(line).width) / 2);
                const textY =
                    height / 2 - ((lines.length - 1) * fontSize) / 2 + index * fontSize;
                ctx.fillText(line, textX, textY);
            });

            ctx.save();
        },
    };
}


export const gaugeSplitArrowPlugin = {
    id: "customSplitArrow",
    afterDraw(chart, args, opts = {}) {
        if (opts.enabled === false) return;

        const meta = chart.getDatasetMeta(0);
        const arcs = meta?.data || [];
        if (!arcs.length) return;

        const splitAtIndex = Math.min(
            Math.max(opts.splitAtIndex ?? 1, 0),
            arcs.length - 1
        );
        const boundaryArc = arcs[splitAtIndex];
        const splitAngle = boundaryArc.startAngle;

        const ctx = chart.ctx;
        const anyArc = arcs[0];
        const centerX = anyArc.x;
        const centerY = anyArc.y;
        const outerR = anyArc.outerRadius;

        const arrowColor = opts.arrowColor || "#000";
        const baseWidth = Number.isFinite(opts.baseWidth) ? opts.baseWidth : 9;
        const startOffset = opts.startOffset || -15;
        const endMargin = opts.endMargin || 30;

        const sx = centerX;
        const sy = centerY + startOffset;

        const endRadius = Math.max(0, outerR - endMargin);
        const x1 = centerX + Math.cos(splitAngle) * endRadius;
        const y1 = centerY + Math.sin(splitAngle) * endRadius;

        const angle = Math.atan2(y1 - sy, x1 - sx);

        const r = Math.max(0.1, baseWidth / 2);

        const startAngle = angle + Math.PI / 2;
        const endAngle = startAngle + Math.PI;

        const startX = sx + Math.cos(startAngle) * r;
        const startY = sy + Math.sin(startAngle) * r;

        ctx.save();
        ctx.fillStyle = arrowColor;
        ctx.lineJoin = "round";
        ctx.lineCap = "round";

        ctx.beginPath();
        ctx.moveTo(startX, startY);
        ctx.arc(sx, sy, r, startAngle, endAngle, false);
        ctx.lineTo(x1, y1);
        ctx.closePath();
        ctx.fill();

        ctx.restore();
    },
};
